module.exports = __webpack_public_path__ + "static/media/map-mobile-icon.b21507ee.svg";